import * as PropTypes from 'prop-types'
import React from 'react'

import DistinctModelObserver from '../../shared/view-models/DistinctModelObserver.ts'
import createParentPropsInjector from '../../shared/utils/create-parent-props-injector'

import viewModelConnector from '../../shared/lib/view-model'

import TranslateBar from '../components/TranslateBar'

export default function connectTranslateBar(parentProps) {
  const injectParentProps = createParentPropsInjector(parentProps)

  // Connector function
  function TranslateBarConnector({ ...rest }) {
    return <TranslateBar {...rest} />
  }

  // Component props
  TranslateBarConnector.propTypes = {
    articleStore: PropTypes.object.isRequired,
  }

  return viewModelConnector([
    {
      class: DistinctModelObserver,
      data: [
        {
          type: 'article',
          id: DistinctModelObserver.fromProps('articleStore.current.id'),
          as: 'translateArticle',
          component: TranslateBar.name,
        },
      ],
      as: 'currentArticle',
    },
  ])(injectParentProps(TranslateBarConnector))
}
